import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#D8FFFF" d="M82.74 10.35a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m103.38 22.82 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM11.52 99.77a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M17.09 71.91h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H2.95c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M33.07 105.77c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M81.93 38.9 59.81 21.27a2.9 2.9 0 0 0-3.63 0L34.06 38.9v39.71c0 2.4 1.95 4.35 4.35 4.35h39.17c2.4 0 4.35-1.95 4.35-4.35zM81.93 36.69V21.08c0-.69-.56-1.26-1.26-1.26h-6.19c-.69 0-1.26.56-1.26 1.26v9.95"
    />
    <path
      fill="#fff"
      d="M51.04 53.16h14.11c1.31 0 2.37 1.06 2.37 2.37v27.43H48.68V55.53c0-1.31 1.06-2.37 2.37-2.37z"
    />
    <path
      fill="#0597A3"
      d="M25.36 46.8c-.92 0-1.83-.42-2.42-1.23-.98-1.34-.69-3.21.65-4.19l30.06-22.05a7.31 7.31 0 0 1 8.69 0l30.07 22.05c1.34.98 1.62 2.86.64 4.19a3.003 3.003 0 0 1-4.19.65L58.8 24.17a1.35 1.35 0 0 0-1.6 0L27.14 46.22c-.53.39-1.16.58-1.77.58zM86.44 85.96H29.31c-1.66 0-3-1.34-3-3s1.34-3 3-3h57.13c1.66 0 3 1.34 3 3s-1.34 3-3 3"
    />
    <path
      fill="#00D8D8"
      d="M58.95 100.14c-.61 0-1.22-.23-1.68-.7-.93-.93-.93-2.43 0-3.36l10.67-10.67c.93-.93 2.43-.93 3.36 0s.93 2.43 0 3.36L60.63 99.44c-.46.46-1.07.7-1.68.7"
    />
    <path
      fill="#0597A3"
      d="M82.74 92.56c10.223 0 18.51-8.287 18.51-18.51s-8.287-18.51-18.51-18.51-18.51 8.287-18.51 18.51 8.287 18.51 18.51 18.51"
    />
    <path
      fill="#00D8D8"
      d="M82.74 88.5c7.98 0 14.45-6.47 14.45-14.45S90.72 59.6 82.74 59.6s-14.45 6.47-14.45 14.45S74.76 88.5 82.74 88.5"
    />
    <path
      fill="#fff"
      d="M87.45 85.01c-.8 0-1.57-.43-1.98-1.18-.59-1.09-.19-2.46.91-3.05a7.66 7.66 0 0 0 4.01-6.73c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25c0 4.46-2.44 8.56-6.37 10.69-.34.18-.71.27-1.07.27"
    />
  </svg>
);
const SvgEnrichedIconSearchHomesBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSearchHomesBrand);
export default Memo;
